import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import type { RouteComponentProps } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import { getConnectionNodes } from '../../common/data/helper'
import { Connection } from '../../common/data/types'
import { RestrictedConsumer } from '../auth/RestrictedContext'
import { i18n } from '../index'
import TaskListTable from '../taskList/TaskListTable'
import { ASSIGNMENTS_QUERY } from '../taskList/data'
import css from './monthlyInfoPage.css'

const DATE_DISPLAY_FORMAT = 'D.M.YYYY'
const DATE_FORMAT = 'YYYY-MM-DD'

type MonthlyInfoTaskTableProps = {
  stationId: string
  subject: string
  month: string
}

class MonthlyInfoTaskTable extends React.Component<MonthlyInfoTaskTableProps & RouteComponentProps> {
  render() {
    const { subject, history, month, stationId } = this.props
    const fromDate = moment(month).startOf('month').format(DATE_FORMAT)
    const toDate = moment(month).endOf('month').format(DATE_FORMAT)
    return (
      <RestrictedConsumer>
        {(hasPermission) => (
          <div className={css.tasksContainer}>
            {hasPermission && (
              <Button
                color='primary'
                variant='contained'
                onClick={() => {
                  history.push('/tehtavalista/uusi-tehtava', {
                    subject: subject,
                    refetchParameters: {
                      stationId,
                      subject: subject,
                      fromDate: fromDate,
                      toDate: toDate,
                      perPage: 100, // TODO: maybe use pagination
                    },
                  })
                }}
              >
                {i18n.t('monthlyInfo.button.createTask')}
              </Button>
            )}
            <Query<
              { assignments: Connection },
              { stationId: string; subject: string; fromDate: string; toDate: string; perPage: number }
            >
              query={ASSIGNMENTS_QUERY}
              variables={{
                stationId,
                subject: subject,
                fromDate: fromDate,
                toDate: toDate,
                perPage: 100, // TODO: maybe use pagination
              }}
            >
              {({ loading, error: _error, data }) => {
                const items = loading ? [] : getConnectionNodes(data.assignments)
                return (
                  <div className={css.taskTable}>
                    <Typography variant='h6' gutterBottom>
                      {i18n.t('monthlyInfo.heading.tasks', {
                        fromDate: moment(fromDate, DATE_FORMAT).format(DATE_DISPLAY_FORMAT),
                        toDate: moment(toDate, DATE_FORMAT).format(DATE_DISPLAY_FORMAT),
                      })}
                    </Typography>
                    <TaskListTable items={items} isLoading={loading} canEdit={hasPermission} />
                  </div>
                )
              }}
            </Query>
          </div>
        )}
      </RestrictedConsumer>
    )
  }
}

export default withRouter(MonthlyInfoTaskTable)
